import { useMemo, useCallback } from "react";
import Dropdown from "./Dropdown";

const DropDownStatus = ({
  value,
  onChange,
  options = [],
  optionsValue = [],
  disabled = false,
}) => {
  const mappedOptions = useMemo(() => {
    const len = Math.min(options.length, optionsValue.length);
    return Array.from({ length: len }).map((_, idx) => ({
      label: options[idx],
      value: optionsValue[idx],
    }));
  }, [options, optionsValue]);

  const handleChange = useCallback(
    (valOrEvent) => {
      const nextValue = valOrEvent?.target?.value ?? valOrEvent;
      onChange?.({ target: { value: nextValue } });
    },
    [onChange],
  );

  return (
    <Dropdown
      variant="select"
      id="status-select"
      value={value}
      onChange={handleChange}
      options={mappedOptions}
      placeholderKey="dropdown.status"
      disabled={disabled}
    />
  );
};

export default DropDownStatus;
